/**
 * DiscardEditsDialog public entry point.
 * Re-exports the stateless copy adapter — this dialog owns no state; the
 * edit-mode hook (`useContractExtractionEditMode`) drives its open / close /
 * confirm lifecycle.
 * @module features/contracts/components/DiscardEditsDialog
 */
export { default } from "./DiscardEditsDialogContainer";
